import { render } from "./Totals.vue?vue&type=template&id=92043b8a&scoped=true"
import script from "./Totals.vue?vue&type=script&lang=js"
export * from "./Totals.vue?vue&type=script&lang=js"

import "./Totals.vue?vue&type=style&index=0&id=92043b8a&scoped=true&lang=css"

import exportComponent from "/Users/matt/websites/code-practice.test/portfolio/expense-tracker/vuecli/expense-tracker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92043b8a"]])

export default __exports__